import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'if',
  version: '1.0.0',
  properties: [
    {
      key: 'conditions',
      label: 'Conditions',
      type: 'fixedCollection',
      required: true,
      typeOptions: {
        multipleValues: true,
      },
      default: {
        values: [
          {
            field1: '',
            operator: '===',
            value: '',
          },
        ],
      },
      fixedCollectionOptions: [
        {
          name: 'values',
          displayName: 'Condition',
          description: 'Add conditions to evaluate',
          values: [
            {
              key: 'field1',
              label: 'Field 1',
              type: 'string',
              required: true,
              placeholder: '{{ $node["NodeName"].string }}',
              description: 'First value to compare (use {{ }} for expressions)',
            },
            {
              key: 'operator',
              label: 'Operator',
              type: 'options',
              required: true,
              default: '===',
              options: [
                { value: '===', name: 'Equals' },
                { value: '!==', name: 'Not Equals' },
                { value: '>', name: 'Greater Than' },
                { value: '>=', name: 'Greater Than or Equal' },
                { value: '<', name: 'Less Than' },
                { value: '<=', name: 'Less Than or Equal' },
                { value: 'contains', name: 'Contains' },
                { value: 'startsWith', name: 'Starts With' },
                { value: 'endsWith', name: 'Ends With' },
                { value: 'isEmpty', name: 'Is Empty' },
                { value: 'isNotEmpty', name: 'Is Not Empty' },
              ],
            },
            {
              key: 'value',
              label: 'Value',
              type: 'string',
              placeholder: 'e.g., "active"',
              description: 'Value to compare against',
              displayOptions: {
                hide: {
                  operator: ['isEmpty', 'isNotEmpty'],
                },
              },
            },
          ],
        },
      ],
    },
    {
      key: 'combineOperation',
      label: 'Combine',
      type: 'options',
      default: 'AND',
      options: [
        { value: 'AND', name: 'AND (all must match)' },
        { value: 'OR', name: 'OR (any must match)' },
      ],
      description: 'How to combine multiple conditions',
    },
  ],
};

export default schema;
